import { Box, Card, Divider, CardContent } from '@mui/material';
import { DistributionListItem } from '../../utils/billing.utils';
import { BillingOrderDiscount } from './billing-order-discount';
import { LegalEntityDistributionCard } from './legal-entity-distribution-card';
import { SecondStepFormValues } from '../../types/billing-form.types';

interface LegalEntityDistributionListProps {
  distributions: DistributionListItem[];
  onAddDocument?: (legalEntityId: string) => void;
  formValues: SecondStepFormValues[];
  visible?: boolean;
}

export const LegalEntityDistributionList = ({
  distributions,
  onAddDocument,
  formValues,
  visible = true,
}: LegalEntityDistributionListProps) => {
  if (!visible || distributions.length === 0) return null;

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
        {formValues.map((value, formValueIndex) => {
          return (
            <Box key={`legal-entity-distribution-list-${value.legalEntity._id}`}>
              <LegalEntityDistributionCard
                formValue={value}
                formValueIndex={formValueIndex}
                onAddDocument={onAddDocument}
              />
            </Box>
          );
        })}

        <Divider />

        <BillingOrderDiscount />
      </CardContent>
    </Card>
  );
};
